import type { TFunction } from "i18next";
import type { IconType } from "../../icon";
import type { LessonProgressStatus, LessonStatusFilter } from "./types";

export const getLessonProgressStatus = (
	progressPercent: number,
): LessonProgressStatus => {
	if (progressPercent >= 100) {
		return "completed";
	}
	if (progressPercent > 0) {
		return "inProgress";
	}
	return "notStarted";
};

type LessonActionConfig = {
	labelKey: string;
	mode: "contained" | "outlined" | "text";
	iconName: IconType;
};

const lessonActionConfigs: Record<LessonProgressStatus, LessonActionConfig> = {
	completed: {
		labelKey: "lessons.explore.card.viewResultsCta",
		mode: "text",
		iconName: "chart-box-outline",
	},
	inProgress: {
		labelKey: "lessons.explore.card.resumeCta",
		mode: "outlined",
		iconName: "play",
	},
	notStarted: {
		labelKey: "lessons.explore.card.openCta",
		mode: "contained",
		iconName: "text-box-outline",
	},
};

export const getLessonActionConfig = (
	status: LessonProgressStatus,
): LessonActionConfig => lessonActionConfigs[status];

type EmptyStateParams = {
	t: TFunction;
	statusFilter: LessonStatusFilter;
	totalLessons: number;
};

type EmptyStateConfig = {
	title: string;
	subtitle: string;
	cta: string;
};

export const getExploreEmptyState = ({
	t,
	statusFilter,
	totalLessons,
}: EmptyStateParams): EmptyStateConfig => {
	if (statusFilter !== "all" && totalLessons > 0) {
		return {
			title: t("lessons.explore.empty.filteredTitle"),
			subtitle: t("lessons.explore.empty.filteredSubtitle"),
			cta: t("lessons.explore.empty.filteredCta"),
		};
	}
	return {
		title: t("lessons.explore.empty.noneTitle"),
		subtitle: t("lessons.explore.empty.noneSubtitle"),
		cta: t("lessons.explore.empty.noneCta"),
	};
};
